/** @jsxImportSource @emotion/react */
import Typography from '@mui/material/Typography'
import { SubjectExtended } from 'hooks/usePlatformsAndSubjects'
import * as classes from './styles'

export type SubjectTabsProps = {
  subjects: SubjectExtended[]
  selectedSubject: SubjectExtended | null
  selectSubject: (subject: SubjectExtended | null) => void
  isToggle?: boolean
  className?: string
}

export const SubjectTabs = ({
  subjects,
  selectedSubject,
  selectSubject,
  isToggle = false,
  className,
}: SubjectTabsProps) => (
  <div css={classes.tabsBlock} className={className}>
    {subjects.map((subject) => {
      const isSelected = selectedSubject?.tabId === subject.tabId

      return (
        <Typography
          onClick={() => selectSubject(isToggle && isSelected ? null : subject)}
          key={subject.tabId}
          css={[classes.tab, isSelected && classes.activeTab]}
          variant="body2"
        >
          {subject.tabName}
        </Typography>
      )
    })}
  </div>
)
